import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconNumber1Circle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconNumber1Circle"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Path d="M11.9785 16.2275V8.94434H11.8848L9.73438 10.5029V9.38965L11.9844 7.77246H13.0332V16.2275H11.9785Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNumber1Circle;
